import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"

import "./List.vue?vue&type=style&index=0&id=97ed9bf2&lang=css"
import "./List.vue?vue&type=style&index=1&id=97ed9bf2&scoped=true&lang=scss"
script.__scopeId = "data-v-97ed9bf2"

export default script